// Custom-domain mode: when the app is opened on a vendor's own domain (not sell24x7.com), show that vendor's store.
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const hostOf = (u) => { try { return new URL(u).hostname.toLowerCase(); } catch { return ""; } };
const backendHost = hostOf(BACKEND);
const MAIN_HOSTS = new Set(
  ["localhost", "stores.sell24x7.com", backendHost, backendHost && `www.${backendHost}`, ...(process.env.REACT_APP_MAIN_HOSTS || "").split(",").map((h) => h.trim().toLowerCase())].filter(Boolean),
);

export const host = typeof window === "undefined" ? "" : window.location.hostname.toLowerCase();
export const isCustomHost = !!host && !MAIN_HOSTS.has(host);
/** On a real (https) vendor domain nginx proxies /api on the same origin, so no cross-origin calls are needed. */
export const sameOriginApi = isCustomHost && window.location.protocol === "https:";

let tenantSlug = null;
export const getTenantSlug = () => tenantSlug;

/** Resolves the store for the current domain. Returns "found" | "missing". */
export async function resolveTenant() {
  if (!isCustomHost) return "main";
  const base = sameOriginApi ? `${window.location.origin}/api` : `${BACKEND}/api`;
  try {
    const res = await fetch(`${base}/domain/resolve?host=${encodeURIComponent(host)}`);
    if (!res.ok) return "missing";
    tenantSlug = (await res.json()).slug;
    return "found";
  } catch { return "missing"; }
}
